// @flow
import { gql } from '@apollo/client'

export const SEND_OPT_IN = gql`
    mutation sendSMSToMember($memberId: String!) {
        sendSMSToMember(req: {memberId: $memberId})
    }
`
